import styled from 'styled-components';

import { flexStart } from '../../style/reusableStyle';

export const ContractDetailsContainerStyled = styled.div`
  max-width: 930px;
  & .section-title {
    margin-bottom: 20px;
  }
`;

// export const InfoRowStyled = styled.div<{ $direction?: 'row' | 'column' }>`
//   display: flex;
//   align-items: ${({ $direction }) =>
//     $direction === 'column' ? 'flex-start' : 'flex-start'};
//   justify-content: flex-start;
//   flex-direction: ${({ $direction }) => $direction || 'row'};
//   gap: ${({ $direction }) => ($direction === 'column' ? '8px' : '12px')};

//   & .title {
//     flex-shrink: 0;
//     color: ${({ theme }) => theme.colors.darkText};
//   }

//   & .value {
//     color: ${({ theme }) => theme.colors.tableBody};
//     white-space: break-spaces;
//   }

//   @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
//     flex-direction: column;
//     gap: 4px;

//     .title {
//       font-weight: 600;
//     }
//   }
// `;

export const UploadedLogosContainerStyled = styled.div`
  ${flexStart};
  gap: 20px;
`;
